import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useAppSelector } from '../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

// Routes & Utils
import { getGroupMemberInfo } from '../../../../routes/doctor/account';
import getStatusColor from '../../../../util/style/getStatusColor';

type Props = {
  item: any;
  onActionsClick: (event: React.MouseEvent<HTMLElement>, item: any) => void;
};

const GroupAccessCard: React.FC<Props> = ({ item, onActionsClick }) => {
  const { t } = useTranslation();
  const colors = useAppSelector(state => state.theme.colors);
  
  const [account, setAccount] = useState<any>(null);
  const [status, setStatus] = useState('');

  useEffect(() => {
    const handleGroupMemberInfo = async () => {
      const res = await getGroupMemberInfo(item._id) as any;
      if (res.data.status === 200) {
        setAccount(res.data.doctor);
        if (res.data.isMainDoctorId) {
          setStatus('admin');
        }
      }
    };

    if (item) {
      handleGroupMemberInfo();
      setStatus(item?.status);
    }
  }, [item]);

  const isAdmin = status === 'admin';

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: colors?.supportEmailBackground,
        borderRadius: '8px',
        p: 2,
        mb: 2,
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
        border: `1px solid ${colors?.supportHistory}`,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        position: 'relative',
      }}
    >
      {/* Card Header: Name and Status */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color={colors?.text}>
            {account?.firstName} {account?.lastName}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {account?.email}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box
            sx={{
              backgroundColor: getStatusColor(status),
              color: 'white',
              borderRadius: '12px',
              px: 1.5,
              py: 0.5,
              fontSize: '12px',
              fontWeight: 'bold',
              textTransform: 'capitalize',
              flexShrink: 0,
            }}
          >
            {t(status)}
          </Box>
          {!isAdmin && (
            <IconButton
              onClick={(e) => onActionsClick(e, item)}
              sx={{
                color: colors?.text,
              }}
            >
              <MoreVertIcon />
            </IconButton>
          )}
        </Box>
      </Box>

      {/* Card Footer: Last Active Date */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
        <Typography variant="caption" color="text.secondary">
          {t('lastActive')}: {account ? moment(account.lastActive).format('LL') : '...'}
        </Typography>
      </Box>

      {/* Actions Button has been moved into the header to prevent overlap */}
    </Box>
  );
};

export default GroupAccessCard;